import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";

export default obj => {
	obj.each(function () {
		const input = $(this),
			max = input.attr("maxlength"),
			cls = input.attr("class").split(" ")[0],
			chars = $("." + cls + "-chars-count", input.parent());

		input.on("input", () => {
			const text = input.val();
			if (text.length > max) {
				input.val(text.substring(0, max));
				chars.text(max);
			} else {
				chars.text(text.length);
			}
		});
	});
};
